import { useGetAshtakvargaQuery } from '@/store/api/ashtakvargaApi';
import Loader from '@/components/Loader';

interface AshtakvargaProps {
  userId: string;
}

const Ashtakvarga = ({ userId }: AshtakvargaProps) => {
  const { data, isLoading, error } = useGetAshtakvargaQuery({ userId });

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <Loader />
      </div>
    );
  }

  if (error || !data) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-center space-y-4">
        <div className="bg-red-50 text-red-500 px-8 py-4 rounded-xl border border-red-100 font-spectral font-semibold shadow-sm">
          Failed to load Ashtakvarga data. Please try again later.
        </div>
      </div>
    );
  }

  const charts = [
    { title: 'SARVASHTAK', url: data.sarvashtak.imageUrl },
    { title: 'ASCENDANT', url: data.ascendant.imageUrl },
    { title: 'SUN', url: data.sun.imageUrl },
    { title: 'MOON', url: data.moon.imageUrl },
    { title: 'MARS', url: data.mars.imageUrl },
    { title: 'MERCURY', url: data.mercury.imageUrl },
    { title: 'JUPITER', url: data.jupiter.imageUrl },
    { title: 'VENUS', url: data.venus.imageUrl },
    { title: 'SATURN', url: data.saturn.imageUrl },
  ];

  return (
    <div className="space-y-8 animate-in fade-in duration-500">
      <div className="border border-[#2DAAFD] rounded-xl p-6 sm:p-10 bg-white shadow-[0_4px_20px_rgba(45,170,253,0.08)]">
        <div className="flex flex-col items-center mb-10">
          <h2 className="font-28 font-semibold font-spectral bg-clip-text text-transparent bg-gradient-to-r from-[#082261] to-[#34065c] text-center uppercase tracking-widest">
            ASHTAKVARGA
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-[#082261] to-[#34065c] mt-3 rounded-full opacity-30"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-10">
          {charts.map((chart, index) => (
            <div key={index} className="flex flex-col items-center group">
              <div className="w-full relative bg-white rounded-xl p-2 border border-[#2DAAFD]/40 shadow-sm transition-all duration-300 group-hover:shadow-[0_8px_25px_rgba(45,170,253,0.15)] group-hover:border-[#2DAAFD]">
                <h3 className="font-spectral font-bold text-[#001B6B] text-center text-base md:text-lg mb-2 mt-1 uppercase tracking-wide">
                  {chart.title}
                </h3>
                <img src={chart.url} alt={chart.title} className="w-full h-auto" loading="lazy" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Ashtakvarga;
